export class InformationRequestDto {
    constructor(data = {}) {
        this.title = data.title ?? ''
        this.information = data.information ?? ''
        this.startDate = data.startDate ?? ''
        this.endDate = data.endDate ?? ''
    }
}